import { IconConstants } from 'cc-common';

export class ActionAccessResultDto {
    code: string;
    title: string;
    description: string;
    internalOnly: boolean;
    specificRoleOnly: boolean;

    // Transient
    visibility: boolean;
    parentCode: string;

    get icon(): string {
        if (this.internalOnly && !this.specificRoleOnly) {
            return IconConstants.LOCK;
        } else if (this.internalOnly && this.specificRoleOnly) {
            return IconConstants.KEY;
        }
        return '';
    }
}
